import {IRouteStore} from '../../router/routing.infra';
import {IGuestController} from '../../components/guest/controller';
import {getRootStore} from '../../app.bootstrap';
import {NwayParticipantState} from './NwayParticipantState';
import {ParticipantController} from './ParticipantController';

export interface IParticipantStore extends IRouteStore {
    guestController?: IGuestController;
    dispose(): void;
}

export class ParticipantStore implements IParticipantStore {
    private readonly _controller: ParticipantController;

    get guestController(): IGuestController | undefined {
        return this._controller.guestController;
    }

    constructor(state: NwayParticipantState) {
        this._controller = new ParticipantController(state, getRootStore().tsReactStateHelper);
    }

    async initStore(): Promise<void> {
        await this._controller.init();
    }

    dispose(): void {}
}
